import { Service } from "onearm";
import { OfflineAPI } from "./OfflineAPI";
import { RemoteAPI } from "./RemoteAPI";

export class Api extends Service {
    #api;
    init() {
        this.paramters = new URLSearchParams(window.location.search);
        this.#api = this.paramters.has("offline")
            ? new OfflineAPI(this.services.get("gameMath"), this.gameConfig)
            : new RemoteAPI(this.services.get("gameMath"), this.gameConfig);
    }

    async spin(parameters) {
        return await this.#api.spin(parameters);
    }

    async player(parameters) {
        return await this.#api.player(parameters);
    }

    async freeSpin(...parameters) {
        return await this.#api.freeSpin(...parameters);
    }

    async buyBonus(parameters) {
        return await this.#api.buyBonus(parameters);
    }

    async buyFreeSpins(...args) {
        return await this.#api.buyFreeSpins(...args);
    }

    async activateBonus(parameters) {
        return await this.#api.activateBonus(parameters);
    }

    async getPayTable(parameters) {
        return await this.#api.getPayTable(parameters);
    }

    async setDoubleChanceFeature(...args) {
        return await this.#api.setDoubleChanceFeature(...args);
    }

    async setBet(...args) {
        return await this.#api.setBet(...args);
    }
}
